import api from './api'

export const sendEmailVerifyCode = async (emailSessionId: string): Promise<void> => {
  await api.post<unknown>('/prelogin/send_email_verify_code', {
    email_session_id: emailSessionId,
  })
}
